package features.booking

import network.FirebaseClient
import kotlinx.coroutines.flow.first

interface CatalogRepository {
    suspend fun getCatalog(category: String): List<String>
    suspend fun saveCatalog(category: String, items: List<String>): Boolean

    suspend fun getPrecios(): Map<String, Int>
    suspend fun savePrecios(precios: Map<String, Int>): Boolean
}

class CatalogRepositoryImpl : CatalogRepository {
    override suspend fun getCatalog(category: String): List<String> {
        return try {
            val db = FirebaseClient.database
            val ref = db.reference("catalogos/$category")
            val snapshot = ref.valueEvents.first()
            if (snapshot.exists) {
                snapshot.value<List<String>?>() ?: emptyList()
            } else {
                emptyList()
            }
        } catch (e: Exception) {
            emptyList()
        }
    }

    override suspend fun saveCatalog(category: String, items: List<String>): Boolean {
        return try {
            val db = FirebaseClient.database
            val ref = db.reference("catalogos/$category")
            ref.setValue(items)
            true
        } catch (e: Exception) {
            false
        }
    }

    override suspend fun getPrecios(): Map<String, Int> {
        return try {
            val db = FirebaseClient.database
            val ref = db.reference("catalogos/precios")
            val snapshot = ref.valueEvents.first()
            if (snapshot.exists) {
                snapshot.value<Map<String, Int>?>() ?: mapOf(
                    "base" to 350,
                    "maleta" to 150,
                    "mascota" to 150
                )
            } else {
                mapOf(
                    "base" to 350,
                    "maleta" to 150,
                    "mascota" to 150
                )
            }
        } catch (e: Exception) {
            mapOf(
                "base" to 350,
                "maleta" to 150,
                "mascota" to 150
            )
        }
    }

    override suspend fun savePrecios(precios: Map<String, Int>): Boolean {
        return try {
            val db = FirebaseClient.database
            db.reference("catalogos/precios").setValue(precios)
            true
        } catch (e: Exception) {
            false
        }
    }
}